import React from 'react';

interface MuteProps {
  size?: number;
}

export const Mute = ({ size = 24 }: MuteProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M22.7334 2.7334L2.7334 22.7334L1.2666 21.2666L21.2666 1.2666L22.7334 2.7334Z'
      fill='currentColor'
    />
    <path
      d='M16.6401 11.9741V22.3022L10.0688 17.5336L11.2876 15.8549L14.5659 18.2338V11.9741H16.6401Z'
      fill='currentColor'
    />
    <path
      d='M3.21289 14.4705V9.42654C3.21289 8.32652 4.07804 7.25662 5.32324 7.25662H8.81738L16.6396 1.59744V8.34549H14.5664V5.65701L9.49023 9.32986H5.33301C5.33064 9.33149 5.32637 9.33418 5.32129 9.33963C5.30056 9.36195 5.28711 9.39571 5.28711 9.42654V14.4705C5.2872 14.4978 5.29735 14.5193 5.30957 14.532L5.32031 14.5398H8.63086V16.614H5.32324C4.10813 16.614 3.21308 15.6021 3.21289 14.4705Z'
      fill='currentColor'
    />
  </svg>
);

interface UnmuteProps {
  size?: number;
}

export const Unmute = ({ size = 24 }: UnmuteProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.6401 11.974V22.3021L10.0688 17.5336L11.2876 15.8549L14.5659 18.2338V11.974H16.6401Z'
      fill='currentColor'
    />
    <path
      d='M3.21289 14.4705V9.42651C3.21289 8.32649 4.07804 7.25659 5.32324 7.25659H8.81738L16.6396 1.59741V8.34546H14.5664V5.65698L9.49023 9.32983H5.33301C5.33064 9.33146 5.32637 9.33415 5.32129 9.3396C5.30056 9.36192 5.28711 9.39568 5.28711 9.42651V14.4705C5.2872 14.4978 5.29735 14.5192 5.30957 14.532L5.32031 14.5398H8.63086V16.614H5.32324C4.10813 16.614 3.21308 15.6021 3.21289 14.4705Z'
      fill='currentColor'
    />
    <path
      d='M16.64 22.3L8.81583 16.6111H5.32113C4.10561 16.6111 3.20996 15.599 3.20996 14.4676V9.42567C3.20996 8.32598 4.07564 7.25638 5.32113 7.25638H8.81679L16.64 1.59998V22.3ZM5.28479 14.4676C5.28479 14.4951 5.29547 14.5169 5.30774 14.5297C5.31258 14.5347 5.31609 14.5368 5.3173 14.5374C5.31768 14.5374 5.31989 14.5383 5.32113 14.5383H9.48992L14.5661 18.228V5.6576L9.488 9.32915H5.32973C5.32728 9.33089 5.32302 9.33358 5.31826 9.3387C5.29753 9.36102 5.28479 9.39484 5.28479 9.42567V14.4676Z'
      fill='currentColor'
    />
  </svg>
);
